<script lang="ts" setup>
import HelpLabel from '@/components/HelpLabel.vue'

defineProps<{
  translationKey?: string
}>()
</script>

<template>
  <h2>
    <span>{{ $t(translationKey || '') }}</span>
    <HelpLabel :translation-key="translationKey" />
  </h2>
</template>

<style lang="scss" scoped>
h2 span {
  font-size: inherit;
}
</style>
